import React, {useEffect, useRef} from 'react';
import {AppState} from 'react-native';

import RecordsScreen from '/component/layout/RecordsScreen';
import {COACH_REPORT} from '/enum/popover.enum';
import {REPORT_CARD_CONTENT_ALL_COACHES} from '/enum/reportCard.enum';
import {SCREEN_NAMES} from '/enum/tealium.enum';
import {withTranslation} from '/provider/TranslationProvider';
import {withHOC} from '/util/hoc.util';

import {ReportProps} from '../Report.types';
import withRecordPopover from '../withRecordPopover';

import MyTeamsContent from './MyTeamsContent.connect';
import reportPayload from './reportPayload';

export const MyTeamsReport = ({
  loadingData = {total: 0},
  tt = (key: string, defaultValue?: string) => defaultValue || '',
  showRecordPopover = () => {},
  resetMyTeamsData = () => {},
  reportHeading = '',
  previousScreenName = '',
}: ReportProps) => {
  const appState = useRef(AppState.currentState);

  useEffect(() => {
    const subscription = AppState.addEventListener('change', nextAppState => {
      if (
        appState.current.match(/inactive|background/) &&
        nextAppState === 'active'
      ) {
        resetMyTeamsData();
      }

      appState.current = nextAppState;
    });

    return () => {
      subscription.remove();
    };
  }, []);
  return (
    <RecordsScreen
      {...reportPayload}
      title={tt('title', 'My Teams')}
      description={tt(
        'description',
        'All Coaches in your organization (all applicable generations).',
      )}
      contentProps={{
        loadingData,
        showRecordPopover,
        reportHeading,
        screenContext: 'my_teams',
        previousScreenName,
        persistenceKey: SCREEN_NAMES.myTeamsReport,
      }}
      contentComponent={MyTeamsContent}
    />
  );
};

export default withHOC(
  withTranslation('report.MyTeams'),
  withRecordPopover({
    reportPayload,
    popoverName: COACH_REPORT,
    popoverContentName: REPORT_CARD_CONTENT_ALL_COACHES,
    popoverContentProps: {
      renderTitle: () =>
        withTranslation.ts('reportRecordTitle.myteams', 'My Teams'),
    },
  }),
)(MyTeamsReport);
